module.exports = __webpack_public_path__ + "static/media/PDF_132.56981013.pdf";